import { render } from "./historyManagement.vue?vue&type=template&id=e6f023d6&scoped=true"
import script from "./historyManagement.vue?vue&type=script&lang=js"
export * from "./historyManagement.vue?vue&type=script&lang=js"

import "./historyManagement.vue?vue&type=style&index=0&id=e6f023d6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6f023d6"]])

export default __exports__